import React from "react";
import ConfigurationPage from "templates/ConfigurationPage";
import UserContent from "./UserContent"

const NewUser = (props) => {
    const {history} = props;
    
    return (
        <ConfigurationPage
            history={history}
            pageTitle="Users"
            pageSubTitle="Add new user"
        >
            <ConfigurationPage.Content>
                <UserContent {...props}/>
            </ConfigurationPage.Content>
        </ConfigurationPage>
    );
};

export default NewUser;